import { render, staticRenderFns } from "./UploadSalesData.vue?vue&type=template&id=76e42254&"
import script from "./UploadSalesData.vue?vue&type=script&lang=js&"
export * from "./UploadSalesData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports